import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { CHECK_IN_METHOD_LABEL } from '../utils/utils';
import type { CheckInMethod } from '../types/types';

type MethodBadgeProps = {
	method: CheckInMethod;
};

// 체크인 처리 방식 배지 (QR / 수동처리)
const MethodBadge = memo<MethodBadgeProps>(({ method }) => {
	return <Wrapper $manual={method === 'MANUAL'}>{CHECK_IN_METHOD_LABEL[method]}</Wrapper>;
});

MethodBadge.displayName = 'MethodBadge';

export default MethodBadge;

const Wrapper = styled.div<{ $manual: boolean }>`
	min-width: 44px;
	height: 24px;
	${({ theme }) => theme.typography.caption};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	border-radius: 4px;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
	background-color: ${({ theme }) => theme.colors.ultraLightGrayBorder};

	// 수동처리는 주의 색상(오렌지)으로 강조
	${({ $manual, theme }) =>
		$manual &&
		css`
			color: ${theme.colors.activeRedOrange};
			background-color: #fff1e8;
		`};
`;
